import { Card } from '../components/ui/Card';
import { CodeSnippet } from '../components/ui/CodeSnippet';
import { TechSelector } from '../components/ui/TechSelector';

import { useAccountNumber } from '/src/hooks';
import { VideoPlayer } from '/src/components/VideoPlayer';
import { ListItem } from '../components/ui/ListItem';
import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';
import GtmPoster from '/src/features/installation/assets/gtm-instructions-poster.jpg';
import GtmVideo from '/src/features/installation/assets/gtm-instructions.mp4';

export function GtmInstructions({ techOptions = [], selectedTechOption = null, onSelectTech }) {
  const [accNumber] = useAccountNumber(false);

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <ol className="flex flex-col gap-4 mb-4">
        <ListItem number={1}>Log into your Google Tag Manager account.</ListItem>

        <ListItem number={2}>
          Click on <strong>Add a New Tag.</strong>
        </ListItem>

        <ListItem number={3}>
          Click on the <strong>Tag Configuration</strong> or the pencil icon. Choose <strong>Crazy Egg.</strong>
        </ListItem>

        <ListItem number={4}>
          Enter your Crazy Egg account number, <strong>{accNumber}</strong> in the <strong>Account Number</strong>{' '}
          field.
        </ListItem>
      </ol>

      <CodeSnippet code={accNumber} />

      <ol className="flex flex-col gap-4 mt-4">
        <ListItem number={5}>
          Click on the <strong>Triggering</strong> section. Select <strong>All Pages</strong> for the trigger.
        </ListItem>

        <ListItem number={6}>
          Click on <strong>Add.</strong> Click on <strong>Save.</strong>
        </ListItem>

        <ListItem number={7}>
          Click on <strong>Submit</strong> at the upper right-hand side of the page.
        </ListItem>

        <ListItem number={8}>
          Click on <strong>Publish.</strong>
        </ListItem>
      </ol>

      <p className="mt-10 text-base font-normal leading-6 text-black-pearl-500 mb-3">
        Watch this video to see these steps:
      </p>

      <VideoPlayer src={GtmVideo} poster={GtmPoster} label="GTM installation video" />

      <div className="flex flex-col gap-1 mt-3">
        <SupportLink
          href={SupportLinks.install.gtm}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Google Tag Manager Setup Guide
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>

      <p className="mt-3 text-black-pearl-500">
        Click on <strong>Check installation</strong> once you have connected Crazy Egg with Google Tag Manager.
      </p>
    </Card>
  );
}
